export default __webpack_public_path__ + "static/media/drivalia-logo.024dbde9.png";